module.exports = __webpack_public_path__ + "static/img/196_TO8_2096_og.14ddaea.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/196_TO8_2096_og.jpg
// module id = lz9R
// module chunks = 0